import type { Mission } from '../missions.ts'

export const sba: Mission = {
  id: "sba",
  name: "Small Business Administration",
  short: "SBA",
  call: "Small Business",
  kind: "independent",
  url: "https://www.sba.gov/",
  established: 1953,
  palette: {
    primary: "#000441",
    secondary: "#e0c15e",
    accent: "#00aeff",
  },
  colorSource: {
    kind: "site",
    url: "https://www.sba.gov/app/themes/sbagov/assets/css/variables/tokens.css",
  },
  motif: "eagle",
  mission: {
    text: "From the beginning, the SBA’s mission has been clear: to help Americans start, build, and grow small businesses.",
    url: "https://www.sba.gov/about-sba/",
  },
  fact: {
    text: "President Dwight D. Eisenhower created the SBA in 1953, in the aftermath of World War II.",
    url: "https://www.sba.gov/about-sba/",
  },
  seal: {
    file: "public/seals/sba.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Small_Business_Administration.svg",
  },
  logo: {
    file: "public/logos/sba.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-SmallBusinessAdmin-Logo.svg",
  },
  identifier: {
    about: "https://www.sba.gov/about-sba/",
    accessibility: "https://www.sba.gov/about-sba/open-government/about-the-sba-gov-website/#accessibility",
    foia: "https://www.sba.gov/about-sba/open-government/about-the-sba-gov-website/#foia",
    noFear: "https://www.sba.gov/about-sba/open-government/about-the-sba-gov-website/#no-fear",
    oig: "https://www.sba.gov/about-sba/oversight-and-advocacy/office-of-inspector-general/",
    performance: "https://www.sba.gov/about-sba/organization/performance/",
    privacy: "https://www.sba.gov/about-sba/open-government/about-the-sba-gov-website/#website-privacy",
  },
  media: {
    photos: [
      {
        file: "/media/sba-gassaway-main-street.jpg",
        small: "/media/sba-gassaway-main-street-sm.jpg",
        alt: "Brick storefronts along a small-town main street under a blue sky, with an American flag and a Shop and Buy Local banner on a utility pole.",
        title: "Downtown Gassaway, West Virginia, May 25, 2023",
        creator: "Lance Cheung, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:RPN_All_Imagery_(20230525-USDA-RD-WV-LSC-0733).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/sba-farmers-market.jpg",
        small: "/media/sba-farmers-market-sm.jpg",
        alt: "Close view of yellow squash in a blue basket at a farmers market vendor's stall.",
        title: "Squash for sale at the USDA Farmers Market, Washington, D.C., May 26, 2017",
        creator: "Lance Cheung, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:USDA_Farmers_Market_(20170526-AMS-LSC-0033).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
